var map = {
	"./about-us-banner-cn.webp": 1546,
	"./about-us-banner-m-cn.webp": 1547,
	"./about-us-banner-m-ms.webp": 1548,
	"./about-us-banner-m.webp": 1549,
	"./about-us-banner-ms.webp": 1550,
	"./about-us-banner.webp": 462,
	"./banner-01.jpg": 1551,
	"./banner-slot.jpg": 1552,
	"./bet-and-earn-banner-cn.webp": 1553,
	"./bet-and-earn-banner-indon.webp": 1554,
	"./bet-and-earn-banner-ms.webp": 1555,
	"./bet-and-earn-banner.webp": 1556,
	"./check-in-banner-cn.webp": 1557,
	"./check-in-banner-id.webp": 1558,
	"./check-in-banner-ms.webp": 1559,
	"./check-in-banner.webp": 1560,
	"./cny_2024-bm.webp": 1561,
	"./cny_2024-cn.webp": 1562,
	"./cny_2024.webp": 1563,
	"./epl-banner-cn.webp": 1564,
	"./epl-banner-indo.webp": 1565,
	"./epl-banner-ms.webp": 1566,
	"./epl-banner.webp": 1567,
	"./games-banners-cn.webp": 1568,
	"./games-banners-ms.webp": 1569,
	"./games-banners.webp": 1570,
	"./lb-m-banner-cn.webp": 1571,
	"./lb-m-banner.webp": 1572,
	"./leaderboard-banner-cn.webp": 1573,
	"./leaderboard-banner.webp": 1574,
	"./lottery-banner.webp": 1575,
	"./lottery-banners-cn.webp": 1576,
	"./lottery-banners-ms.webp": 1577,
	"./lottery-banners.webp": 1578,
	"./lucky-spin-banner-cn.webp": 1579,
	"./lucky-spin-banner-ms.webp": 1580,
	"./lucky-spin-banner.webp": 1581,
	"./p2p-banner.webp": 1582,
	"./p2p-banners-cn.webp": 1583,
	"./p2p-banners-ms.webp": 1584,
	"./p2p-banners.webp": 1585,
	"./premier-league-banner-cn.webp": 1586,
	"./premier-league-banner.webp": 1587,
	"./promo-vip-banner-cn.webp": 1588,
	"./promo-vip-banner-ms.webp": 1589,
	"./promo-vip-banner.webp": 1590,
	"./promos-banner-cn.webp": 1591,
	"./promos-banner-indon.webp": 1592,
	"./promos-banner-ms.webp": 1593,
	"./promos-banner.webp": 1594,
	"./promos-detail-banner.jpg": 1595,
	"./side-bar-banner.jpg": 1596,
	"./slot-banners-cn.webp": 1597,
	"./slot-banners-ms.webp": 1598,
	"./slot-banners.webp": 1599,
	"./speed-banners-cn.webp": 1600,
	"./speed-banners-ms.webp": 1601,
	"./speed-banners.webp": 1602,
	"./vip-banner-cn.webp": 1603,
	"./vip-banner-id.webp": 1604,
	"./vip-banner-m-cn.webp": 1605,
	"./vip-banner-m-ms.webp": 1606,
	"./vip-banner-m.webp": 1607,
	"./vip-banner-ms.webp": 1608,
	"./vip-banner.webp": 1609,
	"./vip-deposit-marathon-challenges-cn.webp": 1610,
	"./vip-deposit-marathon-challenges-ms.webp": 1611,
	"./vip-deposit-marathon-challenges.webp": 1612,
	"./winner-leaderboard-banner-cn.webp": 1613,
	"./winner-leaderboard-banner.webp": 1614,
	"./world-cup-banner-cn.webp": 1615,
	"./world-cup-banner.webp": 1616,
	"./world-cup-two-banner-cn.webp": 1617,
	"./world-cup-two-banner.webp": 1618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;